import { isString } from '@mindtickle/utils';

export const fixPath = (url: string) =>
  url.startsWith('/') ? url : `${window.location.pathname}/${url}`;

export const generateLink = (url: string) => (isString(url) ? fixPath(url) : url);
